import React, { useState } from "react";
import { Button, Input, Typography, message } from "antd";
import { CopyOutlined, CheckOutlined, LinkOutlined } from "@ant-design/icons";
import { authSVC } from "../../services";

const { Text, Title, Paragraph } = Typography;

function LinkGenerate() {
  const [tokenKey, setTokenKey] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isCopied, setIsCopied] = useState(false);

  const demoUrl = tokenKey
    ? `https://www.soulsara.world/full-demo-url?tkn=${tokenKey}`
    : "";

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(demoUrl);
      setIsCopied(true);
      message.success("Link copied to clipboard!");
      setTimeout(() => setIsCopied(false), 2000);
    } catch (err) {
      message.error("Failed to copy. Please copy the link manually.");
    }
  };

  const getCodeDemo = () => {
    setIsLoading(true);
    authSVC
      .getCodeDemoUrl()
      .then((res) => {
        setTokenKey(res.data.data.activationToken);
      })
      .catch(() => {
        message.error("Failed to generate demo link. Please try again.");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className="contentBox">
      <div className="demo-link-generator">
        <div className="demo-link-generator__icon">
          <LinkOutlined />
        </div>

        <Title level={3} className="demo-link-generator__title">
          Demo Link Generator
        </Title>

        <Paragraph className="demo-link-generator__subtitle">
          The link is valid for <Text strong className="day_color">14 days</Text>, granting limited
          access to the community, Wellness Counseling services, or any other
          paid services.
        </Paragraph>

        {tokenKey ? (
          <div className="demo-link-generator__result">
            <div className="demo-link-generator__link-box">
              <Input.TextArea
                className="demo-link-generator__link-text"
                value={demoUrl}
                readOnly
                autoSize={{ minRows: 2, maxRows: 3 }}
                onClick={(e) => (e.target as HTMLTextAreaElement).select()}
              />
            </div>

            <Button
              type="primary"
              className="demo-link-generator__btn"
              icon={isCopied ? <CheckOutlined /> : <CopyOutlined />}
              onClick={copyToClipboard}
              block
            >
              {isCopied ? "Copied!" : "Copy Link"}
            </Button>

            <Button
              type="link"
              className="demo-link-generator__regenerate"
              onClick={getCodeDemo}
              loading={isLoading}
            >
              Generate a new link
            </Button>
          </div>
        ) : (
          <Button
            type="primary"
            className="demo-link-generator__btn"
            onClick={getCodeDemo}
            loading={isLoading}
            block
          >
            {isLoading ? "Generating..." : "Create Demo URL"}
          </Button>
        )}
      </div>
    </div>
  );
}

export default LinkGenerate;